// src/pages/employee/AddEmployee.jsx

import React, { useState, useRef, useEffect } from 'react';
import { Info, X, ChevronDown, ChevronUp, Search, Eraser } from 'lucide-react';
import { useHistory } from "react-router-dom";
import Tooltip from '../addentities/Tooltip.js';
import apiHelper from '../../apiHelper';

export default function AddPermissionGroup() {
    const history = useHistory();

    //
    // ─── Employees MULTI-SELECT STATE & HANDLERS ────────────────────────────────────
    //
    // const allEmployees = [
    //     { label: 'Kai', value: 'Kai' },
    //     { label: 'Leong', value: 'Leong' },
    //     { label: 'John', value: 'John' },
    //     { label: 'Lee', value: 'Lee' },
    // ];
    const [allEmployees,setAllEmployees]=useState([])
    const [isEmployeesOpen, setisEmployeesOpen] = useState(false);
    const [employeesSearch, setEmployeesSearch] = useState('');
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const employeesRef = useRef(null);

    // Toggle dropdown open/closed
    const toggleEmployees = () => {
        setisEmployeesOpen((prev) => !prev);
    };
    useEffect(() => {
    async function fetchEmployees() {
        try {
            const employeesRes = await apiHelper('users/list/');
            if (employeesRes.ok) {
                const result = await employeesRes.json();
                // Ensure the API response is mapped to the expected format
                const formattedEmployees = result.map(employee => ({
                    employee_id: employee.id, // Adjust based on your API response
                    display_name: employee.display_name,
                    label: employee.display_name, // Ensure label is set for consistency
                    value: employee.id // Ensure value is set for consistency
                }));
                setAllEmployees(formattedEmployees);
            }
        } catch (error) {
            console.error('Failed to fetch employees:', error);
        }
    }
    fetchEmployees();
}, []); // Empty dependency array to run once on mount
    // Close dropdown if clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isEmployeesOpen && employeesRef.current && !employeesRef.current.contains(e.target)) {
                setisEmployeesOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isEmployeesOpen]);

    // Filtered list based on search text
    const filteredEmployees = allEmployees.filter((d) =>
        d.display_name.toLowerCase().includes(employeesSearch.trim().toLowerCase())
    );

    // Add/remove Employees from selectedEmployees
    const handleEmployeesCheckbox = (employee) => {
    setSelectedEmployees((prev) => {
        const exists = prev.findIndex((item) => item.employee_id === employee.employee_id);
        if (exists > -1) {
            // Remove if already selected
            return prev.filter((item) => item.employee_id !== employee.employee_id);
        } else {
            // Add the employee with consistent structure
            return [...prev, {
                employee_id: employee.employee_id,
                display_name: employee.display_name,
                label: employee.display_name,
                value: employee.employee_id
            }];
        }
    });
};

    // Remove a tag when “×” is clicked
    const removeEmployees = (valueToRemove) => {
        setSelectedEmployees((prev) =>
            prev.filter((item) => item.value !== valueToRemove)
        );
    };

    //
    // ─── BREADCRUMBS & HEADER HANDLERS ─────────────────────────────────────────────
    //
    const [activeTab] = useState("Add Permission Group");
    const breadcrumbs = ["Permission", "Permission Group", activeTab];

    const handleSave = () => {
        console.log("Saving employee with:");
        console.log(" • Selected employees:", selectedEmployees);
        // insert your actual save logic here
    };

    const handleDiscard = () => {
        history.goBack();
    };
    const [isEntityOpen, setIsEntityOpen] = useState(false);
    const entityRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isEntityOpen && entityRef.current && !entityRef.current.contains(e.target)) {
                setIsEntityOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isEntityOpen]);

    const [checked, setChecked] = useState({
        admin: false,
        overview: false,
        orgMgmt: false,
        company: false,
        department: false,
        employee: false,
        permission: false,
        permissionGroup: false,
    });

    const [expanded, setExpanded] = useState({
        orgMgmt: true,
        permission: true,
    });

    // Handle checkbox changes with cascading logic
    const handleCheckboxChange = (key) => {
        let updated = { ...checked };

        switch (key) {
            case 'admin':
                updated = {
                    admin: !checked.admin,
                    overview: !checked.admin,
                    orgMgmt: !checked.admin,
                    company: !checked.admin,
                    department: !checked.admin,
                    employee: !checked.admin,
                    permission: !checked.admin,
                    permissionGroup: !checked.admin,
                };
                break;
            case 'orgMgmt':
                updated = {
                    ...checked,
                    orgMgmt: !checked.orgMgmt,
                    company: !checked.orgMgmt,
                    department: !checked.orgMgmt,
                    employee: !checked.orgMgmt,
                };
                updated.admin = isAllAdminChecked(updated);
                break;
            case 'permission':
                updated = {
                    ...checked,
                    permission: !checked.permission,
                    permissionGroup: !checked.permission,
                };
                updated.admin = isAllAdminChecked(updated);
                break;
            default:
                updated[key] = !checked[key];
                updated.orgMgmt = areAllOrgChildrenChecked(updated);
                updated.permission = areAllPermissionChildrenChecked(updated);
                updated.admin = isAllAdminChecked(updated);
                break;
        }

        setChecked(updated);
    };

    const isAllAdminChecked = (state) =>
        state.overview &&
        state.orgMgmt &&
        state.company &&
        state.department &&
        state.employee &&
        state.permission &&
        state.permissionGroup;

    const areAllOrgChildrenChecked = (state) =>
        state.company && state.department && state.employee;

    const areAllPermissionChildrenChecked = (state) => state.permissionGroup;

    const toggleExpand = (key) => {
        setExpanded({ ...expanded, [key]: !expanded[key] });
    };

    const [modalOpen, setModalOpen] = useState(false);

    const modalRef = useRef();
    const searchInputRef = useRef();

    const [modalChecked, setModalChecked] = useState({});
    const [modalExpanded, setModalExpanded] = useState({});
    const [selected, setSelected] = useState([]);
    const [search, setSearch] = useState('');

    const groups = [
        { name: 'Pricing', members: ['Alice', 'Bob'] },
        { name: 'HR', members: ['Lena', 'Mark'] },
        { name: 'Finance', members: ['Jade', 'Rick'] },
        { name: 'Operation', members: ['Nancy'] },
        { name: 'Logistic', members: ['Tom'] },
        { name: 'Marketing', members: ['Emily'] },
        { name: 'IT', members: ['Kai', 'Leong'] },
        { name: 'Project Team', members: ['Nora', 'Luke'] },
        { name: 'Product Team', members: ['James'] },
        { name: 'Customer Service Sales', members: ['Derek'] }
    ];

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setModalOpen(false);
            }
        };
        if (modalOpen) document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [modalOpen]);

    const toggleModalExpand = (group) => {
        setModalExpanded((prev) => ({ ...prev, [group]: !prev[group] }));
    };

    const toggleCheck = (name) => {
        setModalChecked((prev) => ({ ...prev, [name]: !prev[name] }));
        setSelected((prev) =>
            prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
        );
    };

    const clearAllSelected = () => {
        setSelected([]);
        setModalChecked({});
    };

    const toggleSelectAll = () => {
        const allMembers = groups.flatMap((g) => g.members);
        const isAllSelected = allMembers.every((m) => selected.includes(m));

        if (isAllSelected) {
            setSelected([]);
            setModalChecked({});
        } else {
            const newChecked = {};
            allMembers.forEach((m) => (newChecked[m] = true));
            setSelected(allMembers);
            setModalChecked(newChecked);
        }
    };

    const renderSelected = () => (
        <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
            {selected.map((name) => (
                <div
                    className="d-flex align-items-center justify-content-between mb-2"
                    key={name}
                >
                    {/* Left: Circle + Name */}
                    <div className="d-flex align-items-center">
                        <div
                            style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                                backgroundColor: '#E9ECEF',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '4px',
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: 600,
                                fontSize: '14px',
                                color: '#000000',
                                textTransform: 'uppercase',
                                flex: 'none',
                            }}
                        >
                            {name.charAt(0)}
                        </div>
                        <span
                            style={{
                                fontSize: '14px',
                                fontFamily: 'Montserrat, sans-serif',
                                color: '#000',
                            }}
                        >
                            {name}
                        </span>
                    </div>

                    {/* Right: Close icon */}
                    <X
                        size={18}
                        style={{ cursor: 'pointer', color: 'black' }}
                        onClick={() => toggleCheck(name)}
                    />
                </div>
            ))}
        </div>
    );


    const filteredGroups = groups.map((group) => ({
        ...group,
        members: group.members.filter((member) =>
            member.toLowerCase().includes(search.toLowerCase())
        ),
    })).filter((group) => group.members.length > 0 || group.name.toLowerCase().includes(search.toLowerCase()));

    // if (!modalOpen) return null;


    return (
        <>
            <div className="company-body main-company-body-inner">
                {/* ─── BREADCRUMB ───────────────────────────────────────────────────── */}
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "Permission Group" ? "clickable" : ""
                                    }`}
                                onClick={() => {
                                    if (crumb === "Permission Group") {
                                        history.push("/permission-group");
                                    }
                                }}
                                style={{ cursor: crumb === "Permission Group" ? "pointer" : "default" }}
                            >
                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>

                {/* ─── PAGE HEADER ─────────────────────────────────────────────────────── */}
                <div className='edit-organisation-info'>
                    <div className='edit-organisation-left'>
                        <h1>Add Permission Groups</h1>
                    </div>
                    <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                        <button
                            className="dark-button"
                            type='button'
                            onClick={handleDiscard}
                        >
                            Cancel
                        </button>
                        <button
                            className="dark-border"
                            type='button'
                            // onClick={handleSave}
                            onClick={() => setModalOpen(true)}
                        >
                            Add Permission Group
                        </button>
                    </div>
                </div>

                {/* ─── MAIN FORM ───────────────────────────────────────────────────────── */}
                <div className="info-section">
                    {/* ─── EMPLOYEE INFO CARD ─────────────────────────────────────────── */}
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Basic Info</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>

                                {/* ─── ROW 1: NAME & STATUS ───────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label
                                                htmlFor="name"
                                                className="form-label d-flex align-items-center gap-2"
                                            >
                                                Name <span className='error-color'>*</span>
                                                <Tooltip content="A shorter, human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control common-input-all"
                                                id="name"
                                                placeholder="Your Name"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="status" className="form-label">
                                                Status <span className='error-color'>*</span>
                                            </label>
                                            <div className='flexing-type-radio'>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        id="flexRadioDefault1"
                                                        defaultChecked
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexRadioDefault1"
                                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                    >
                                                        Active

                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        id="flexRadioDefault2"
                                                        
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexRadioDefault2"
                                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                    >
                                                        Inactive
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div> {/* end of grid-info-adding */}
                        </div> {/* end of info-content */}
                    </div> {/* end of info-card */}
                    {/* ─── Accessible Apps CARD ─────────────────────────────────────────── */}
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Accessible Apps</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12 custom-check'>
                                        <h3 className='field-value mb-3 fw-bold'>
                                            <div className="d-flex align-items-center">
                                                <input
                                                    className="form-check-input me-2"
                                                    type="checkbox"
                                                    checked={checked.admin}
                                                    onChange={() => handleCheckboxChange('admin')}
                                                />
                                                Admin
                                            </div>
                                        </h3>
                                        <ul className='field-value-listing'>
                                            <li className="field-value">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        className="form-check-input me-2"
                                                        type="checkbox"
                                                        checked={checked.overview}
                                                        onChange={() => handleCheckboxChange('overview')}
                                                    />
                                                    Overview
                                                </div>
                                            </li>

                                            {/* Organisation Management */}
                                            <li className="field-value">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="d-flex align-items-center">
                                                        <input
                                                            className="form-check-input me-2"
                                                            type="checkbox"
                                                            checked={checked.orgMgmt}
                                                            onChange={() => handleCheckboxChange('orgMgmt')}
                                                        />
                                                        Organisation Management
                                                    </div>
                                                    <div style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={() => toggleExpand('orgMgmt')}>
                                                        {expanded.orgMgmt ? <ChevronDown size={16} strokeWidth={3} /> : <ChevronUp size={16} strokeWidth={3} />}
                                                    </div>
                                                </div>
                                                {expanded.orgMgmt && (
                                                    <ul className='field-value-listing'>
                                                        {['company', 'department', 'employee'].map((key) => (
                                                            <li className="field-value" key={key}>
                                                                <div className="d-flex align-items-center">
                                                                    <input
                                                                        className="form-check-input me-2"
                                                                        type="checkbox"
                                                                        checked={checked[key]}
                                                                        onChange={() => handleCheckboxChange(key)}
                                                                    />
                                                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>

                                            {/* Permission */}
                                            <li className="field-value">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="d-flex align-items-center">
                                                        <input
                                                            className="form-check-input me-2"
                                                            type="checkbox"
                                                            checked={checked.permission}
                                                            onChange={() => handleCheckboxChange('permission')}
                                                        />
                                                        Permission
                                                    </div>
                                                    <div style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={() => toggleExpand('permission')}>
                                                        {expanded.permission ? <ChevronDown size={16} strokeWidth={3} /> : <ChevronUp size={16} strokeWidth={3} />}
                                                    </div>
                                                </div>
                                                {expanded.permission && (
                                                    <ul className='field-value-listing'>
                                                        <li className="field-value">
                                                            <div className="d-flex align-items-center">
                                                                <input
                                                                    className="form-check-input me-2"
                                                                    type="checkbox"
                                                                    checked={checked.permissionGroup}
                                                                    onChange={() => handleCheckboxChange('permissionGroup')}
                                                                />
                                                                Permission Group
                                                            </div>
                                                        </li>
                                                    </ul>
                                                )}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div> {/* end of grid-info-adding */}
                        </div> {/* end of info-content */}
                    </div> {/* end of info-card */}

                    {/* ─── Authorized Employees CARD ─────────────────────────────────────────── */}
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Authorized Employees</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>
                                {/* ─── ROW 1: Employees ─────────────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div
                                            className="info-inner"
                                            ref={employeesRef}
                                            style={{ position: 'relative' }}
                                        >
                                            <label className="form-label d-flex align-items-center gap-2">
                                                Employees <span className='error-color'>*</span>
                                                <Tooltip content="Select one or more employees for this employee">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>

                                            {/* CLOSED VIEW: tags + arrow */}
                                           <div
                                                className="select-box form-control common-input-all"
                                                onClick={toggleEmployees}
                                                style={{
                                                    padding: '0.5rem',
                                                    minHeight: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {selectedEmployees.length > 0 ? (
                                                    selectedEmployees.map((employee) => (
                                                        <span
                                                            key={employee.employee_id}
                                                            className="tag"
                                                            style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}
                                                        >
                                                            {employee.label || employee.display_name}
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    removeEmployees(employee.employee_id);
                                                                }}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '8px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}
                                                            >
                                                                <X size={14} strokeWidth={3} />
                                                            </button>
                                                        </span>
                                                    ))
                                                ) : (
                                                    <span style={{ color: '#999', fontSize: '0.9rem' }}>
                                                        Select Employees
                                                    </span>
                                                )}

                                                {/* Selected count */}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginLeft: 'auto',
                                                        gap: '0.25rem',
                                                        fontSize: '0.8rem',
                                                        color: '#666',
                                                    }}
                                                >
                                                    {selectedEmployees.length > 0 && (
                                                        <span>{selectedEmployees.length} selected</span>
                                                    )}
                                                    <ChevronDown
                                                        size={16}
                                                        style={{
                                                            transform: isEmployeesOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s',
                                                            userSelect: 'none',
                                                        }}
                                                    />
                                                </span>
                                            </div>

                                            {/* DROPDOWN PANEL (visible when isEmployeesOpen) */}
                                            {isEmployeesOpen && (
                                                <div
                                                    className="options-container"
                                                    style={{
                                                        border: '1px solid #6c757d',
                                                        borderRadius: '8px',
                                                        marginTop: '4px',
                                                        maxHeight: '270px',
                                                        overflowY: 'auto',
                                                        background: '#fff',
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        zIndex: 1000,
                                                        width: '100%',
                                                        boxshadow: '0px 1px 4px 0px #0000001A',
                                                    }}
                                                    onWheel={(e) => e.preventDefault()}
                                                >
                                                    {/* Search input with icon */}
                                                    <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                        <Search
                                                            size={18}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '18px',
                                                                transform: 'translateY(-50%)',
                                                                color: '#6C757D',
                                                                pointerEvents: 'none',
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="search-input select-box form-control common-input-all"
                                                            placeholder="Search..."
                                                            value={employeesSearch}
                                                            onChange={(e) => setEmployeesSearch(e.target.value)}
                                                            style={{
                                                                width: '100%',
                                                                padding: '0.5rem 0.5rem 0.5rem 2rem',
                                                                fontSize: '0.9rem',
                                                                outline: 'none',
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Options list */}
                                                    <ul
                                                        className="options-list custom-check"
                                                        style={{
                                                            listStyle: 'none',
                                                            margin: 0,
                                                            padding: '1.25rem',
                                                        }}
                                                    >
                                                        {filteredEmployees.map((d) => (
                                                            <li key={d.employee_id} style={{ marginBottom: '0.5rem' }}>
                                                                <label
                                                                    className="option-item"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        fontSize: '0.9rem',
                                                                        fontWeight: 'normal',
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={
                                                                            selectedEmployees.findIndex(
                                                                                (item) => item.employee_id === d.employee_id
                                                                            ) > -1
                                                                        }
                                                                        onChange={() => handleEmployeesCheckbox(d)}
                                                                        style={{ marginRight: '8px' }}
                                                                    />
                                                                    {d.display_name}
                                                                </label>
                                                            </li>
                                                        ))}

                                                        {/* If no employees match search */}
                                                        {filteredEmployees.length === 0 && (
                                                            <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                                                No employees found
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ─── ADDITIONAL INFO CARD ─────────────────────────────────────────── */}
                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Additional Info</h4>
                        </div>
                        <div className="info-content">
                            <div className="info-inner common-textarea">
                                <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                >
                                    Note
                                </label>
                                <textarea
                                    className="form-control w-100 common-textarea-all"
                                    id="exampleFormControlTextarea1"
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div> {/* end of info-section */}

                {modalOpen && (
                    <>
                        <div className="drawer-overlay" />
                        <div
                            className="entity-drawer modal-popup-cls"
                            ref={modalRef}
                            style={{
                                maxWidth: 800,
                                margin: '0 auto',
                                background: 'white',
                                borderRadius: 12,
                                zIndex: 1050,
                                padding: 24,
                                position: 'fixed',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
                                height: 'auto',
                                right: 'auto',
                                overflow: 'inherit',
                            }}
                        >
                            <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                <button className="close-btn" onClick={() => setModalOpen(false)}>
                                    <X size={20} />
                                </button>
                            </div>

                            <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "15px" }}>Select Employees</h3>

                            <div className='d-flex' style={{ gap: '30px' }}>
                                <div style={{ width: '50%' }}>
                                    <div className="position-relative w-100">
                                        <Search size={18} style={{ position: 'absolute', top: '50%', left: 10, transform: 'translateY(-50%)', color: '#6C757D' }} />
                                        <input
                                            ref={searchInputRef}
                                            type="text"
                                            className="form-control ps-5"
                                            placeholder="Search..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            style={{
                                                boxShadow: 'none',
                                                border: '1px solid #6C757D',
                                                borderRadius: '8px',
                                                outline: 'none',
                                                fontWeight: 400,
                                                fontSize: '14px',
                                                lineHeight: '18px',
                                                fontFamily: '"Montserrat", sans-serif',
                                                color: '#6C757D',
                                                padding: '10px',
                                                marginBottom: '15px'
                                            }}
                                        />
                                    </div>
                                    <div className="custom-check" style={{ maxHeight: 350, overflowY: 'auto' }}>
                                        <ul className="field-value-listing p-0">
                                            <li className="field-value">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        className="form-check-input me-2"
                                                        type="checkbox"
                                                        checked={selected.length === groups.flatMap(g => g.members).length}
                                                        onChange={toggleSelectAll}
                                                    />
                                                    Select All
                                                </div>
                                            </li>
                                            {filteredGroups.map((group) => (
                                                <li key={group.name} className="field-value" style={{ paddingLeft: '22px' }}>
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                        <div className="d-flex align-items-center">
                                                            <input
                                                                className="form-check-input me-2"
                                                                type="checkbox"
                                                                checked={group.members.length > 0 && group.members.every(m => modalChecked[m])}
                                                                onChange={() => group.members.forEach((m) => toggleCheck(m))}
                                                            />
                                                            {group.name}
                                                        </div>
                                                        <div style={{ cursor: 'pointer' }} onClick={() => toggleModalExpand(group.name)}>
                                                            {modalExpanded[group.name] ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                                        </div>
                                                    </div>
                                                    {modalExpanded[group.name] && (
                                                        <ul className="field-value-listing ps-4">
                                                            {group.members.map((member) => (
                                                                <li className="field-value" key={member}>
                                                                    <div className="d-flex align-items-center">
                                                                        <input
                                                                            className="form-check-input me-2"
                                                                            type="checkbox"
                                                                            checked={modalChecked[member] || false}
                                                                            onChange={() => toggleCheck(member)}
                                                                        />
                                                                        {member}
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                <div style={{ width: '50%' }}>
                                    <div className='d-flex justify-content-between align-items-center mb-3'>
                                        <div style={{ fontSize: 14 }}>{selected.length} Employee selected</div>
                                        <button
                                            onClick={clearAllSelected}
                                            title="Clear selected"
                                            style={{
                                                boxShadow: '0px 1px 4px 0px #0000001A',
                                                backgroundColor: '#6C757D',
                                                width: '34px',
                                                height: '34px',
                                                borderRadius: '8px',
                                                color: '#FFFFFF',
                                                border: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: 0,
                                                marginLeft: '1rem', // to replicate `ms-3`
                                                cursor: 'pointer',
                                                flex: 'none'
                                            }}
                                        >
                                            <Eraser size={18} />
                                        </button>
                                    </div>
                                    {renderSelected()}
                                </div>
                            </div>

                            <div className="drawer-footer d-flex justify-content-end gap-2 mt-4">
                                <button className="btn-cancel" onClick={() => setModalOpen(false)}>
                                    Cancel
                                </button>
                                <button className="btn-save" onClick={() => console.log('Selected:', selected)}>
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div> {/* end of company-body */}
        </>
    );
}
